import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportUrls } from '@custom/Utils/constants/apiUrls';

const saveProcessedReportsApi = createAsyncThunk('saveProcessedReportsApi', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = _reportUrls.saveProcessedReports;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Failed to fetch patient details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default saveProcessedReportsApi;
